import { render, staticRenderFns } from "./main.vue?vue&type=template&id=997a0fc8&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997a0fc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('997a0fc8')) {
      api.createRecord('997a0fc8', component.options)
    } else {
      api.reload('997a0fc8', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=997a0fc8&scoped=true", function () {
      api.rerender('997a0fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting-phone/common/components/startOne/main.vue"
export default component.exports